// extracted by mini-css-extract-plugin
module.exports = {"linkItem":"az__Bb","labelLinkItem":"az_aCb","commonCookieBtnStyles":"az_bCb","cookieButtonElement":"az_cCb","cookieStick":"az_dCb"};